import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from 'modules/redux/constants'
import setReduxAction from 'modules/redux/actions/set'
import { GIFT_DOMAIN, GIFT_KEY, GIFT_PATH } from 'modules/gift/redux/constants'
import updateAmountGiftUtil from 'modules/gift/utils/update-amount'
import { GIFT_CARD_AMOUNTS } from 'modules/gift/constants'
import logUtil from 'utils/log'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'

export default function updateAmountGiftAction (value) {
  return async (dispatch) => {
    value = value || (isSelfGiftingUrlLocationUtil() ? 0 : GIFT_CARD_AMOUNTS[0])
    logUtil('updateAmountGiftAction').debug(`[start] value=${value}`)

    const key = GIFT_KEY.AMOUNT
    const action = getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.UPDATE,
      GIFT_DOMAIN,
      key
    )
    const path = GIFT_PATH[key]
    dispatch(
      setReduxAction({
        type: action,
        payload: {
          path,
          value
        }
      })
    )
    updateAmountGiftUtil(value)

    // const isInGiftingMode = isInGiftingModeGiftSelect(getState())
    // if (!isInGiftingMode) {
    //   return
    // }
  }
}
